/**
 * ¿Este usuario manda en la cuenta? — ADR-2026-09-15-sin-dueno-manda-quien-esta-adentro.
 *
 * Fuente ÚNICA de la regla, y existe por un incidente: el guard de dueño (Suscripción,
 * Facturación, Checkout, Paywall) comparaba `owner_user_id === user.id` a secas, o sea que una
 * empresa con `owner_user_id` null dejaba a su propio usuario sin poder pagar. Del 12 al 15/09
 * el alta no seteaba la columna y 48 cuentas nuevas quedaron sin forma de contratar un plan —
 * ninguna llegó siquiera al checkout.
 *
 * La regla correcta para un candado de PLATA es fallar ABIERTO: se bloquea sólo cuando se sabe
 * que el dueño es OTRA persona. "No sé quién es el dueño" nunca puede significar "no podés
 * pagar". Con un solo perfil en la empresa —el caso de todas las que se rompieron— además es
 * literalmente cierto: si no hay dueño anotado, el que está adentro es el dueño.
 *
 * **Recibe la FILA de la empresa, no su `owner_user_id`.** Es a propósito: con el id suelto,
 * "la empresa no tiene dueño" (fail-open, correcto) y "no pude leer la empresa" (no se sabe
 * nada, tiene que fallar cerrado) llegaban acá como el mismo `undefined`. Así un error
 * transitorio de red le abría el checkout de dueño a un miembro cuya empresa SÍ tiene otro
 * dueño — lo marcó Greptile en el PR #115. Sin fila, no se afirma nada.
 *
 * El backend tiene la MISMA regla en `services/equipo/logic.ts` (`mandaEnLaCuenta`), que usan
 * `puedeCrearLink`, `GET /v1/equipo` (`soy_dueno`) y `DELETE /v1/equipo/link`. Si cambia acá,
 * cambia allá. La excepción deliberada es sacar gente (`puedeSacar`), que sigue cerrada.
 */
export function esDuenoDeLaCuenta(
  empresa: { owner_user_id?: string | null } | null | undefined,
  userId: string | null | undefined,
): boolean {
  // Sin usuario no hay nada que afirmar (no hay sesión resuelta todavía).
  if (!userId) return false;
  // Sin la fila de la empresa TAMPOCO: no saber quién es el dueño porque la consulta falló
  // no es lo mismo que saber que no tiene.
  if (!empresa) return false;
  // Con la fila leída y sin dueño anotado: manda quien está adentro.
  if (!empresa.owner_user_id) return true;
  return empresa.owner_user_id === userId;
}

export default esDuenoDeLaCuenta;
